export default () => ({
  field: {
    backgroundColor: '#000000',
    outline: 'none',
    padding: 0,
  },
  fieldContainer: {
    margin: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    cursor: 'move',
    outline: 'none',
    padding: 0,
    top: 0,
    left: 0,
  },
});
